import { cookie } from "@otto-ec/global-resources/cookie";
import { isEmptyObject } from "@otto-ec/global-resources/core";

import { exactagScope, jsonParseSafe } from "../core/utils.js";
import { exactagData, type ExactagData } from "../core/data.js";

const log = exactagScope.scope("collect.pminfo");

export function addElchCookieData(data = exactagData): ExactagData {
  const pmInfoCookie = cookie.get("pmInfo");
  /*                                    */
  if (!pmInfoCookie) return data;

  /*                                                     */
  const pmInfo = jsonParseSafe<ExactagData>(pmInfoCookie);
  if (!pmInfo) {
    log.warn("could not read pmInfo cookie. invalid json");
    /*                                                                                  */
    cookie.remove("pmInfo", { path: "/", domain: ".otto.de" });
    return data;
  }

  if (pmInfo.pi_send === "true") {
    log.info("Marketing object has already been sent.");
    return data;
  }

  /*                                                                            */
  const mo: ExactagData = {};
  Object.entries(pmInfo)
    /*                                   */
    .filter(([pm]) => pm.length === 2)
    .forEach(([pm, value]) => {
      mo[pm] = value;
    });

  /*                                                                     */
  pmInfo.pi_send = "true";
  cookie.set("pmInfo", JSON.stringify(pmInfo), { path: "/", domain: ".otto.de" });

  /*                                                    */
  if (isEmptyObject(mo)) return data;
  data.mo = mo;

  log.info("Added marketing object.", mo);
  return mo;
}
